<script>
    import CollapseIcon from "./CollapseIcon.svelte";

    export let title = "";
    export let index = 0;
    export let setActive = () => {
    };

    let isOpen = false;

    function toggleItem() {
        setActive({index, open, close});
    }

    // Add this function to close the item
    function close() {
        isOpen = false;
    }

    function open() {
        isOpen = true;
    }

</script>

<style>
    .accordion-item {
        border-bottom: 1px solid var(--black-100);
    }

    .accordion-title {
        cursor: pointer;
        padding: 1em;
        user-select: none;
        font-weight: bold;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-right: 32px;
    }

    .accordion-title:hover {
        background-color: #e0e0e0;
    }

    .accordion-content {
        height: 0;
        overflow: hidden;
    }

    .accordion-content.open {
        height: auto;
        padding: 32px;
        padding-left: 48px;
    }
</style>

<div class="accordion-item">
    <div class="accordion-title" on:click={toggleItem}>
        <div style="font-weight: bold" class="text-l">
            {title}
        </div>
        <CollapseIcon isOpen={isOpen}/>
    </div>

    <div class="accordion-content" class:open={isOpen}>
        <slot/>
    </div>
</div>
